const getSearchAfter = ({ files, moreType, }) => {
    var _a;
    const searchAfter = (_a = files
        .filter((file) => file.type === moreType && file.sort !== undefined)) === null || _a === void 0 ? void 0 : _a.slice(-1)[0].sort;
    return searchAfter;
};
export default getSearchAfter;
